import { BLUE_500, LILAC_500, WHITE } from '../colors';
var sliderConfig = {
  config: {
    trackBackgroundColor: BLUE_500,
    trackProgressColor: LILAC_500,
    thumbColor: BLUE_500,
    thumbBorderColor: WHITE,
    platform: {
      mobile: {
        trackHeigh: 4,
        thumbSize: 20,
        thumbBorderWidth: 4
      },
      desktop: {
        trackHeigh: 6,
        thumbSize: 24,
        thumbBorderWidth: 6
      }
    }
  }
};
export default {
  light: sliderConfig,
  dark: sliderConfig,
  white: sliderConfig
};